import { render, staticRenderFns } from "./PastFairWrapper.vue?vue&type=template&id=c453edba&scoped=true"
import script from "./PastFairWrapper.vue?vue&type=script&lang=js"
export * from "./PastFairWrapper.vue?vue&type=script&lang=js"
import style0 from "./PastFairWrapper.vue?vue&type=style&index=0&id=c453edba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c453edba",
  null
  
)

export default component.exports